import { useState } from 'react';
import { Checkbox, Collapse, Grid, Typography } from '@mui/material'
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import _ from 'lodash';
import { Cargo } from '../../../../ts/Cargo';

interface CustomFieldsCenterProps {
    cargoResponse: Cargo;
}

export default function CustomFieldsCenter(props: CustomFieldsCenterProps) {
    const { cargoResponse } = props;
    const [open, setOpen] = useState<boolean>(false);
    const { t } = useTranslation();

    const handleClick = () => {
        setOpen(!open);
    };

    const styles = {
        customFieldsText: {
            fontWeight: 500,
        },
        fileContainer: {
            border: '2px solid',
            borderColor: '#D3D3DE',
            mt: .5
        }
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 1 }}
        >
            <Grid item md={11} xs={12} >
                <ListItemButton sx={{ backgroundColor: '#F8F8F9' }} onClick={handleClick} >
                    <ListItemText>
                        <Typography color="#636383" sx={styles.customFieldsText}>{t('control.centerControl.moreDetails')}</Typography>
                    </ListItemText>
                    {open ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
            </Grid>
            <Grid item md={11}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    {
                        (_.has(cargoResponse, 'customFields.CustomFields.Field') && Array.isArray(cargoResponse['customFields']['CustomFields']['Field'])) ?
                            <Grid container>
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                {cargoResponse['customFields']['CustomFields']['Field'].map((field: any) => (
                                                    <TableCell align="center" key={field['Name']}>{field['Name']}</TableCell>
                                                ))}
                                                {cargoResponse?.dimensions?.freightClass?.class !== '' && (
                                                    <>
                                                        <TableCell align="center">{t("control.eventHistory.scanDetails.freightClass")}</TableCell>
                                                        <TableCell align="center">{t("control.eventHistory.scanDetails.itemNumber")}</TableCell>
                                                        <TableCell align="center">{t("control.eventHistory.scanDetails.subItemNumber")}</TableCell>
                                                    </>
                                                )}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                {cargoResponse['customFields']['CustomFields']['Field'].map((field: any) => {
                                                    if (field['Value'] === true || field['Value'] === false) {
                                                        return <TableCell align="center" key={field['Name']}><Checkbox disabled checked={field['Value']} /></TableCell>
                                                    }
                                                    return <TableCell align="center" key={field['Name']}>{field['Value'] ? field['Value'] : "-"}</TableCell>
                                                })}
                                                {cargoResponse?.dimensions?.freightClass?.class !== '' && (
                                                    <>
                                                        <TableCell align="center">{cargoResponse?.dimensions?.freightClass?.class ?? '-'}</TableCell>
                                                        <TableCell align="center">{cargoResponse?.dimensions?.freightClass?.itemNumber ?? '-'}</TableCell>
                                                        <TableCell align="center">{cargoResponse?.dimensions?.freightClass?.subItemNumber ?? '-'}</TableCell>
                                                    </>
                                                )}
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            :
                            ''
                    }
                </Collapse>
            </Grid>
        </Grid>
    )
}